"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetQuestConfigsResponseToJSON = exports.GetQuestConfigsResponseFromJSONTyped = exports.GetQuestConfigsResponseFromJSON = void 0;
var _1 = require("./");
function GetQuestConfigsResponseFromJSON(json) {
    return GetQuestConfigsResponseFromJSONTyped(json, false);
}
exports.GetQuestConfigsResponseFromJSON = GetQuestConfigsResponseFromJSON;
function GetQuestConfigsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paginationInfo': (0, _1.PaginationInfoFromJSON)(json['paginationInfo']),
        'questConfigs': (json['questConfigs'].map(_1.QuestConfigFromJSON)),
    };
}
exports.GetQuestConfigsResponseFromJSONTyped = GetQuestConfigsResponseFromJSONTyped;
function GetQuestConfigsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paginationInfo': (0, _1.PaginationInfoToJSON)(value.paginationInfo),
        'questConfigs': (value.questConfigs.map(_1.QuestConfigToJSON)),
    };
}
exports.GetQuestConfigsResponseToJSON = GetQuestConfigsResponseToJSON;
